import { ROUTE_PATHS } from "@/shared/constants/route-paths";

export const AUTH_RETURN_TO_PARAM = "return_to";

function isSafeInternalPath(value: string): boolean {
  return (
    value.startsWith("/") &&
    !value.startsWith("//") &&
    !value.startsWith("/\\")
  );
}

export function getAuthReturnPath(search: string): string | null {
  const value = new URLSearchParams(search).get(AUTH_RETURN_TO_PARAM);
  return value && isSafeInternalPath(value) ? value : null;
}

export function buildLoginPath(returnPath: string): string {
  if (!isSafeInternalPath(returnPath)) return ROUTE_PATHS.LOGIN;

  const params = new URLSearchParams({
    [AUTH_RETURN_TO_PARAM]: returnPath,
  });
  return `${ROUTE_PATHS.LOGIN}?${params.toString()}`;
}

export function resolvePostLoginPath({
  onboardingPending,
  returnPath,
}: {
  onboardingPending: boolean;
  returnPath: string | null;
}): string {
  if (onboardingPending) return ROUTE_PATHS.ONBOARDING;
  return returnPath ?? ROUTE_PATHS.MINE;
}
